export enum QuarterOverviewStateEnum {
  INIT,
  LOADING,
  QUERY_ERROR,
  NO_ITEM_FOUND,
  MULTIPLE_ITEM_FOUND,
  SUCCESS,
}
